const API_BASE = '/api';

async function request<T>(
    path: string,
    options: RequestInit = {}
): Promise<T> {
    const token = localStorage.getItem('token');

    const isFormData = options.body instanceof FormData;

    const headers: Record<string, string> = {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        Accept: 'application/json',
        ...(options.headers as Record<string, string>),
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers,
    });

    if (response.status === 401 && !path.startsWith('/login') && !path.startsWith('/register')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        const fallback = response.status === 413
            ? 'File is too large.'
            : `Request failed (HTTP ${response.status})`;
        throw new ApiError(response.status, error.message || fallback, error.errors);
    }

    if (response.status === 204) {
        return {} as T;
    }

    return response.json();
}

export class ApiError extends Error {
    constructor(
        public status: number,
        message: string,
        public errors?: Record<string, string[]>
    ) {
        super(message);
    }
}

export const api = {
    get: <T>(path: string) => request<T>(path),
    post: <T>(path: string, data?: unknown) =>
        request<T>(path, {
            method: 'POST',
            body: data instanceof FormData ? data : JSON.stringify(data),
        }),
    put: <T>(path: string, data?: unknown) =>
        request<T>(path, { method: 'PUT', body: JSON.stringify(data) }),
    delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};
